import { call, put } from 'redux-saga/effects'
import { apiConfig } from '../../../../../config/api-config'
import { makeAccess } from '../../../../../config/factory-controller'
import { GetUserRepository } from '../../../data/repositories/get-user-repository'
import type {
  GetUserParams,
  GetUserResult,
} from '../../../domain/models/get-user'
import { GetUserService } from '../../../service/get-user-service'
import { GetUserController } from '../../controllers/get-user-controller'
import * as action from '../actions/get-user-actions'

export const controller = async (payload: GetUserParams) => {
  const { key, token } = await makeAccess()
  const dataSource = new GetUserService(apiConfig(key, token))
  const repository = new GetUserRepository(dataSource)
  const control = new GetUserController(repository)
  return await control.get(payload)
}

export function* getUserSaga({ payload }: any): any {
  try {
    const result: GetUserResult = yield call(controller, payload)
    yield put(action.getUserSuccess(result))
  } catch (error: any) {
    yield put(action.getUserError(error.toString()))
  }
}
